import { Theme, colors } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(3)
    },
    results: {
        marginTop: theme.spacing(3)
    },
    content: {
        padding: 0
    },
    inner: {
        minWidth: 800
    },
    actions: {
        justifyContent: "flex-end"
    },
    linkButton: {
        //margin: theme.spacing(1),
    },
    marginBottom: {
        marginBottom: theme.spacing(1)
    },

    datesBlock: {
        fontFamily: "Nunito",
        fontSize: 18,
        backgroundColor: "rgba(173,2,163, 0.1)",
        margin: theme.spacing(1),

        [theme.breakpoints.down("xs")]: {
            fontSize: 14
        },

        ".MuiGrid-spacing-xs-1 > & .MuiGrid-item": {
            padding: theme.spacing(1.5),

            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(1)
            }
        }
    },

    constrainedContent: {
        [theme.breakpoints.up("sm")]: {}
    },
    nowrap: {
        whiteSpace: "nowrap"
    },
    datesBlockCheckIn: {
        borderColor: "#f2f2f2",
        borderStyle: "solid",
        borderTopWidth: 2,
        borderBottomWidth: 2,
        borderLeftWidth: 0,
        borderRightWidth: 1
    },
    datesBlockCheckOut: {
        borderColor: "#f2f2f2",
        borderStyle: "solid",
        borderTopWidth: 2,
        borderBottomWidth: 2,
        borderLeftWidth: 1,
        borderRightWidth: 0
    },
    datesBlockDisclosure: {
        borderColor: "#f2f2f2",
        borderStyle: "solid",
        borderWidth: 0,
        borderTopWidth: 2
    },
    marinBlock: {
        margin: theme.spacing(2)
    },
    variedDatesMessage: {
        color: colors.red[600]
    }
}));
